import gql from 'graphql-tag';

export default gql`
    mutation AuthLoginViaFacebook($token: String!) {
        auth {
            loginViaFacebook(token: $token) {
                ... on OauthToken {
                    token
                }
                ... on OauthException {
                    code
                }
            }
        }
    }
`;
